export default __webpack_public_path__ + "static/auditoria-2561d48a73fc73112ca1c46589dd759d.pdf";